import { render, staticRenderFns } from "./organization-units.vue?vue&type=template&id=5317dc60&scoped=true&"
import script from "./organization-units.vue?vue&type=script&lang=js&"
export * from "./organization-units.vue?vue&type=script&lang=js&"
import style0 from "./organization-units.vue?vue&type=style&index=0&id=5317dc60&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5317dc60",
  null
  
)

export default component.exports